import { displayDate } from 'shared/libs/dayjs/helpers'

const Date = (props: any) => {
  const { children, dateFormat } = props

  const value = children?.[1]

  if (!value) return '-'

  return displayDate(value, dateFormat)
}

export default Date
